"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.toMarkdown = void 0;
const md_utils_1 = require("../../../export/md.utils");
const rich_text_1 = require("@vedalib/rich-text");
const toMarkdown = (element, context) => {
    if (!element.value) {
        return '';
    }
    const sections = [];
    const cardSideToMarkdown = (side, title) => {
        const parts = [];
        parts.push(`**${title}**\n`);
        if (side.image) {
            const url = (0, md_utils_1.getFileUrl)(side.image, context);
            if (url) {
                parts.push(`![Image](${url})\n`);
            }
        }
        if (side.label) {
            const content = (0, rich_text_1.slateToMarkdown)(side.label, {
                allowHtmlStyles: context.withStyle,
                allowAlignment: context.withStyle,
                allowCaptionHtml: context.withStyle,
            }).trim();
            if (content) {
                parts.push(content);
            }
        }
        return parts.join('\n');
    };
    if (element.value.front) {
        const frontContent = cardSideToMarkdown(element.value.front, 'Card Front');
        if (frontContent) {
            sections.push(frontContent);
        }
    }
    if (element.value.back) {
        const backContent = cardSideToMarkdown(element.value.back, 'Card Back');
        if (backContent) {
            sections.push(backContent);
        }
    }
    if (sections.length === 0) {
        return '';
    }
    return sections.join('\n\n') + '\n\n';
};
exports.toMarkdown = toMarkdown;
